// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__kI64y","measure":"Tag_measure__gzisb"};